export default __webpack_public_path__ + "static/media/folderIcon.a679134e.svg";